/* New Vue approach */
import JobDetail from 'controller/jobDetail/JobDetail.vue';
import { initializeFrontend } from 'util/vue/app-factory';
import './styles.scss';

initializeFrontend(JobDetail);
